import { SearchModelFactory } from "./SearchModelFactory";
const SearchProviderFactory = new SearchModelFactory();
export default SearchProviderFactory;